import React, { JSX } from 'react';
import { Button, InputText } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { FormInputNameConfirmEmail } from '../types';

interface StateProps {
  state: boolean;
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
  onConfirmEmail: () => void;
  onResendEmail: () => void;
}

type Props = StateProps & DispatchProps;

export const ConfirmEmailContent: React.FC<Props> = ({
  formData,
  formErrors,
  onChangeFormInput,
  onConfirmEmail,
  onResendEmail,
  state,
}): JSX.Element => (
  <div>
    <div className="mt-8 w-full">
      <form onSubmit={e => e.preventDefault()}>
        <div className="mb-[20px]">
          <InputText
            name="confirmationCode"
            label="Código de confirmação"
            placeholder="123456"
            className={`appearance-none w-full
                          rounded-md text-heading leading-tight focus:outline-none
                          focus:shadow-outline text-xs font-dmsans font-normal`}
            value={formData[FormInputNameConfirmEmail.confirmationCode]}
            type="number"
            onChange={e =>
              onChangeFormInput(FormInputNameConfirmEmail.confirmationCode)(e.target.value)
            }
            error={formErrors.confirmationCode && formErrors.confirmationCode[0]}
          />
        </div>

        <div className="flex flex-col gap-4">
          <Button
            type="button"
            title="Validar código de confirmação"
            buttonStyle="primary"
            size="xlg"
            className="w-full"
            onClick={onConfirmEmail}
            disabled={
              // formData[FormInputNameConfirmEmail.email] === '' ||
              formData[FormInputNameConfirmEmail.confirmationCode] === '' || state
            }
          />
          <Button
            type="button"
            title="Reenviar código de confirmação"
            buttonStyle="outlined"
            size="xlg"
            className="w-full"
            onClick={onResendEmail}
            disabled={formData[FormInputNameConfirmEmail.phone] === '' || state}
          />
        </div>
      </form>
    </div>
  </div>
);
